<template>
    <div class="express_box">
        <a-radio-group :value="localExpressId" @change="changeExpress">
            <a-space direction="vertical" :size="20">
                <div v-for="item in expressList" :key="item.id">
                    <a-radio :value="item.id" :disabled="item.disabled">
                        <a-space :size="10" class="ml15">
                            <img v-if="item.logo != ''" class="logo" :src="item.logo" />
                            <img v-else src="@/assets/images/basic/moren.png" class="logo">
                            <span>{{ item.name }}</span>
                            <img v-if="item.tag != ''" class="tag" :src="item.tag" />
                            <span v-if="item.price > 0 && !discount" class="price">{{ `￥${Number(item.price).toFixed(2)}` }}</span>
                            <span v-else-if="item.price > 0 && discount" class="price">{{ `￥${Number(item.price - discount.price).toFixed(2)}` }}</span>
                            <span v-if="item.des" class="text_remark">{{ `（${item.des}）` }}</span>
                        </a-space>
                    </a-radio>
                </div>
            </a-space>
        </a-radio-group>
    </div>
</template>

<script>
export default {
    name: 'SelectExpress',
    model: {
        prop: 'expressId',
        event: 'change'
    },
    props: ["weight", "expressId", "cityId", "districtId", "provinceId", "townId", "isCloudHouse", "isAlone", "catIds", "totalGoodsNum","goods","method","freightDiscount"],
    data() {
        return {
            expressList: [], //快递公司列表
            localExpressId: this.expressId, // 使用 data 存储 expressId
            cloudHouse: false,
            isAloneGoods: false,
            zxExpressId:[],
            discount: null
        }
    },
    watch: {
        expressId(newVal) {
            this.localExpressId = newVal;
        },
        weight: {
            handler(val) {
                if (val > 0 && this.provinceId > 0 && this.cityId > 0) {
                    this.getExpressList();
                }
            },
            deep: true,
            immediate: true,
        },
        cityId: {
            handler(val) {
                if (val > 0 && this.provinceId > 0 && this.weight > 0) {
                    this.getExpressList();
                }
            },
            deep: true,
            immediate: true,
        },
        districtId: {
            handler(val) {
                if (this.weight > 0 && this.provinceId > 0 && this.cityId > 0) {
                    this.getExpressList();
                }
            },
            deep: true,
            immediate: true,
        },
        provinceId: {
            handler(val) {
                if (val > 0 && this.weight > 0 && this.cityId > 0) {
                    this.getExpressList();
                }
            },
            deep: true,
            immediate: true,
        },
        townId: {
            handler(val) {
                if (val > 0) {
                    this.getExpressList();
                }
            },
            deep: true,
            immediate: true,
        },
        isCloudHouse: {
            handler(val) {
                this.cloudHouse = val == null || !val ? false : true
                this.getExpressList();
            },
            deep: true,
            immediate: true,
        },
        isAlone: {
            handler(val) {
                this.isAloneGoods = val > 1 ? false : true;
                this.getExpressList();
            },
            deep: true,
            immediate: true,
        },
        catIds: {
            handler(val) {
                if (val && val.length > 0) {
                    this.getExpressList();
                }
            },
            deep: true,
            immediate: true,
        },
        goods: {
            handler(val) {
                if (val && val.length > 0) {
                    this.getExpressList();
                }
            },
            deep: true,
            immediate: true,
        },
        freightDiscount: {
            handler(val) {
                this.discount = val;
            },
            deep: true,
            immediate: true,
        }
    },
    created() {
        this.getExpressList();
        if (this.method === 'mz') {
            this.getZxExpress();
        }
    },
    methods: {
        getZxExpress(){
            if (this.$route.query.id == null) {
                this.$message.error('未指定订单ID');
                this.$router.go(-1);

                return false;
            }

            this.$util.api('/mz/info', {
                id: this.$route.query.id
            }, res => {
                if (res.code == 10000) {
              if(res.data.express.length>0){
                this.zxExpressId=[];
                for(var i=0;i<res.data.express.length;i++){
                            this.zxExpressId.push(res.data.express[i].express_id)
                        }
                    }
                } else {
                    this.$message.error(res.msg);
                    this.$router.go(-1);
                }
            });
        },
        getExpressList() {
            this.$util.api('/express', {
                weight: this.weight,
                city_id: this.cityId,
                district_id: this.districtId,
                province_id: this.provinceId,
                street_id: this.townId,
                is_cloudhouse: this.cloudHouse ? 1 : 0,
                catids: this.catIds ? this.catIds.join(',') : '',
                num: this.totalGoodsNum,
                goods:this.goods ? (this.goods.length>0? JSON.stringify(this.goods):''):[]
            }, res => {
                if (res.code == 10000) {
                    var data = [];
                    var disable = [];
                    var last = [];

                    for (var i = 0; i < res.data.length; i++) {
                        res.data[i].disabled=false;
                        if (res.data[i].price == -1) {
                            res.data[i].disabled=true;
                            disable.push(res.data[i]);
                        } else if (res.data[i].name.indexOf('物流') !== -1 || res.data[i].name.indexOf('跑腿送货') !== -1) {
                            last.push(res.data[i]);
                        } else {
                            data.push(res.data[i]);
                        }
                        if(this.zxExpressId.length>0 && this.zxExpressId.indexOf(res.data[i].id) === -1){
                          res.data[i].disabled=true;
                        }
                    }

                    this.expressList = data.sort(this.compare('price')).concat(last).concat(disable);
                    // console.log(this.expressId,this.expressList,this.expressList.filter(item => item.price && item.price > 0));
                    if (this.expressList.filter(item => item.price && item.price > 0).length > 0 && (this.localExpressId == '' || this.localExpressId == 0)) {
                        this.localExpressId = this.expressList.filter(item => item.price > 0)[0].id;
                    }

                    for (var i = 0; i < res.data.length; i++) {
                        if (res.data[i].id == this.localExpressId) {
                            this.$emit('change', res.data[i].id, this.expressList);
                            break;
                        }
                    }
                }
            });
        },
        compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        },
        changeExpress(e) {
            const id = e.target.value;
            this.localExpressId = id; // 更新本地的 expressId
            // console.log(this.cityId);
            // if(this.districtId=='' || this.cityId==''){
            // if(this.cityId == ''){
            //     this.$message.error('请补充收件人信息');
            // }else{
                this.$emit('change', id, this.expressList)
            // }
        },
        validate() {
            return new Promise((resolve, reject) => {
                if (this.localExpressId) {
                    resolve();
                } else {
                    reject(new Error('express has error'))
                }
            })
        }
    },
    }
</script>

<style scoped>
.tag {
    height: 20px;
}

.price {
    color: #fd5902;
}

.express_box {
    padding: 10px 15px;
    background: #fff;
    border-radius: 8px;
}

.ml15>>>.text_remark {
    color: #8b572a;
    font-family: Lucida Grande, Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
}

.ml15 {
    margin-left: 15px;
}

.ml15>>>span {
    font-family: Lucida Grande, Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}

.logo {
    height: 40px;
}

.express_logo {
    border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/express/SelectExpress.vue